export default "__VITE_ASSET__DPYgRgm5__"